/* Shim for the forked design editor: no feature tiers in Brightivity. */
export default function FeatureGate({ children }) { return children; }
